
import React, { useEffect, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Modal } from 'bootstrap';
import { Helmet } from 'react-helmet';
import TapSelect from '../../../components/ui/TapSelect';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { Link } from 'react-router-dom';
import swal from "sweetalert";
import { toast } from 'react-toastify';

const SectionList = ({ history }) => {

    const sectionUrl        =   BACKOFFICE_BASE_URL + '/section';

    const access_token = useSelector(state => state.auth.access_token);
    const permissions       =   useSelector(state => state.app.acl_info?.permissions || []);

    const initSearchForm = {
        search_component: '',
        search_subComponent: '',
    };

    const searchFormLabel = {
        search_component: 'Component : ',
        search_subComponent: 'Sub Component : ',
    };

    const [listingLoading, setListingLoading] = useState(false);
    const [sectionListing, setSectionListing] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [sectionSearchForm, setSectionSearchForm] = useState({ ...initSearchForm });
    const [submittedSectionFilterForm, setSubmittedSectionFilterForm] = useState({ ...initSearchForm });
    const [formSearchedElems, setFormSearchedElems] = useState([]);
    const [searchModal, setSearchModal] = useState(null);
    const [subSectionList, setSubSectionList] = useState([]);

    useEffect(() => {
        getSearchFormData()
    }, []) 

    useEffect(() => {
        loadListingTblData(1);
        const modal = new Modal(document.getElementById('searchModal'), { keyboard: false, backdrop: false });
        setSearchModal(modal);
    }, [formSearchedElems]);

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 50, ...submittedSectionFilterForm };
        HttpAPICall.withAthorization('GET', sectionUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setSectionListing(respData.data);
            setListingMeta({
                'from'          :   respData.from, 
                'to'            :   respData.to, 
                'total'         :   respData.total, 
                'last_page'     :   respData.last_page, 
                'per_page'      :   respData.per_page, 
                'current_page'  :   respData.current_page
            });
        }).then(() => setListingLoading(false));
    };

    const addSectionFormInit = () => {
        history.push('/add_section');
    };
    const editSectionInit = (item) => {
        history.push({ pathname: `/add_section`, state: { editSectionData: item } });
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(sectionSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {

            let label = searchFormLabel[key];
            let value = sectionSearchForm[key];

            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'search_component') {
                        show_val = sectionSearchForm ? sectionSearchForm.search_component : '';
                    }
                    if (key == 'search_subComponent') {
                        show_val = sectionSearchForm ? subSectionList.filter(sb => sectionSearchForm.search_subComponent.includes(sb.value)).map(s => s.label).join(', ') : '';
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setSubmittedSectionFilterForm(pre => ({ ...pre, ...sectionSearchForm }));
        setFormSearchedElems(pre => ([...searchedElems]));
        searchModal.hide();
    }
    const tapSelectChange = (selectedOption, form, formKey) => {
        if (form && formKey) {
            const newStateData = Array.isArray(selectedOption)
                ? { ...sectionSearchForm, [formKey]: selectedOption.length > 0 ? selectedOption.map(o => o.value) : [] }
                : { ...sectionSearchForm, [formKey]: selectedOption ? selectedOption.value : '' };

            setSectionSearchForm(newStateData);
        }
    };

    const getSearchFormData = () => {
        HttpAPICall.withAthorization('GET', sectionUrl + '/form_data', access_token, {}, {}, (resp) => {
            let respData = resp.data.sub_sections;
            setSubSectionList(respData && respData.length > 0 ? respData.map(v => ({ value: v.id, label: v.subcomponent })) : []);
        })
    }

    const sectionSearchClear = () => {
        setFormSearchedElems([]);
        setSectionSearchForm({ ...initSearchForm });
        setSubmittedSectionFilterForm({ ...initSearchForm });
        loadListingTblData(1);
        searchModal.hide();
    };

    const deleteSection =   (id) => {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this permanently?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', sectionUrl + '/delete/' + id, access_token,{},{},(resp) => {
                    toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    loadListingTblData(1)
                });
            }
        });
    }

    const sectionJsx = () => {
        return (
            <Ax>
                <div className="page_title row m0">
                    <div>
                        <h3>Section List</h3>
                        <div className="text-end mt15">
                            <Ax>
                                {permissions.includes('asset_section_add') && (
                                <button type="button" className="btn btn-primary" onClick={addSectionFormInit}>New</button>
                                )}
                                <button type="button" className="btn btn-secondary" onClick={() => searchModal.show()} disabled={listingLoading}>
                                    <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                </button>
                            </Ax>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{sectionListingJsx()}</div>
                    </div>
                </div>
            </Ax>
        );
    };

    const sectionListingJsx = () => {
        return (
            <Ax>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={sectionSearchClear} />
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            <Ax>
                                <th scope="col" style={{ width: "5%" }}>S.No</th>
                                <th scope="col">Section</th>
                                <th scope="col" style={{ width: "40%" }}>SubSection</th>
                                <th scope="col" className="text-center" style={{ width: "25%" }}>Description</th>
                                <th scope="col" className="text-center" style={{ width: "10%" }}>Action</th>
                            </Ax>
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="5"><Loader /></td></tr>)
                            : (sectionListing && sectionListing.length > 0
                                ? (sectionListing.map((item, index) => (
                                    <tr key={index}>
                                        <Ax>
                                            <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                            <td>{item.name ? item.name : "-"}</td>
                                            <td>{item.sub_sections.map(s => s.subcomponent)?.join(", ")}</td>
                                            <td>{item.notes || "-"}</td>
                                            <td className='text-center'>
                                                <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                { permissions.includes('asset_section_edit') &&
                                                    <li onClick={() => editSectionInit(item)}><Link className="dropdown-item" role="button">Edit</Link></li>
                                                }
                                                { permissions.includes('asset_section_delete') &&
                                                    <li onClick={() => deleteSection(item.id)}><Link className="dropdown-item" role="button">Delete</Link></li>
                                                }
                                                </ul>
                                            </td>
                                        </Ax>
                                    </tr>
                                )))
                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </Ax>
        );
    };
    
    const searchModalJsx = () => {
        return (
            <div className="modal fade" id="searchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Section Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="sectionSearchForm" onSubmit={submitSearchForm}>
                            <div className="modal-body">
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Section</label>
                                    <div className="col-sm-10">
                                        <input
                                            name="search_component"
                                            type="text"
                                            value={sectionSearchForm.search_component}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => setSectionSearchForm(pre => ({ ...pre, ...sectionSearchForm, search_component: e.target.value }))}
                                            placeholder="Please enter Section Name"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Sub Section</label>
                                    <div className="col-sm-10">
                                        <TapSelect
                                            options={subSectionList}
                                            changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'sectionSearchForm', 'search_subComponent')}
                                            value={subSectionList.filter(u => sectionSearchForm?.search_subComponent?.includes(u.value))}
                                            isSearchable={true}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder="Select SubSection"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Section Listing</title></Helmet>
            {sectionJsx()}
            {searchModalJsx()}
        </ApplicationLayout>
    );
};

export default SectionList;
